import { Button, EditIcon, LoadingButton } from '@cmg/design-system';
import type { VFC } from 'react';
import { Fragment } from 'react';

export type PageGridSectionActionsProps = {
  readonly isSubmitting: boolean;
  readonly isEditing: boolean;
  readonly onEdit: () => void;
  readonly onCancel: () => void;
  readonly onSave?: () => void;
  readonly canEdit?: boolean;
};

export const PageGridSectionActions: VFC<PageGridSectionActionsProps> = ({
  isSubmitting,
  isEditing,
  onEdit,
  onCancel,
  onSave,
  canEdit,
}) => {
  return (
    <Fragment>
      {isEditing && (
        <Fragment>
          <Button key="cancel-button" variant="outlined" onClick={onCancel} disabled={isSubmitting}>
            Cancel
          </Button>
          <LoadingButton
            key="save-button"
            variant="contained"
            type="submit"
            disabled={isSubmitting}
            loading={isSubmitting}
            onClick={onSave}
          >
            Save
          </LoadingButton>
        </Fragment>
      )}
      {!isEditing && canEdit && (
        <Button key="edit-button" variant="text" startIcon={<EditIcon />} onClick={onEdit}>
          Edit
        </Button>
      )}
    </Fragment>
  );
};
